import React, { useCallback, useState } from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { Button, Stack, useToast } from "native-base";
import { useUserIDToken } from "../../../hooks/useUserIDToken.web";
import Subsection from "../../typo/Subsection";
import ActiveState from "../../shared/ActiveState";
import { useCurrentTenantPrefix } from "../../../hooks/useCurrentTenantPrefix";
import { getBackendURL } from "../../../environment";

type Props = {
  user: DocumentSnapshot<DocumentData>;
};

export default function ChangeStatus({ user }: Props) {
  const [tenantId] = useCurrentTenantPrefix();
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const getUserIDToken = useUserIDToken();

  const userData = user.data();

  if (!userData) {
    return null;
  }

  const { isActive, eMail } = userData;

  const changeUserState = useCallback(
    async (newState: boolean) => {
      setLoading(true);

      const authToken = await getUserIDToken();

      try {
        const response = await fetch(`${getBackendURL()}/users/changeState`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            authToken,
            tenantId,
            eMail,
            newState,
          }),
        });

        const json = await response.json();

        const { success, error } = json;

        if (success) {
          toast.show({
            placement: "top",
            title: newState
              ? "Der Benutzer wurde erfolgreich aktiviert."
              : "Der Benutzer wurde erfolgreich deaktiviert.",
          });
        } else {
          if (error) {
            toast.show({
              placement: "top",
              title: error,
            });
          } else {
            throw new Error(JSON.stringify(json));
          }
        }
      } catch (e) {
        console.error(e);

        toast.show({
          placement: "top",
          title:
            "Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.",
        });
      }

      setLoading(false);
    },
    [tenantId, toast, setLoading]
  );

  return (
    <Stack space={4}>
      <Subsection title="Status ändern" />

      <ActiveState isActive={isActive} />

      <Button isLoading={isLoading} onPress={() => changeUserState(!isActive)}>
        {isActive ? "Benutzer deaktivieren" : "Benutzer aktivieren"}
      </Button>
    </Stack>
  );
}
